import { resource, RequestConfig } from '../helper/resource';

/**
 * [No Auth]查询token，计算签名
 */
export function utilServer_querySignatureUsingGET(
  req: UtilServer.QuerySignatureUsingGETQuery | void,
  config?: RequestConfig
): Promise<any> {
  return resource.getNoAuth('/api/wechat/querySignature', req, config);
}

/**
 * [No Auth]查询token，计算签名
 */
export function utilServer_querySignatureByPostUsingPOST(
  req: UtilServer.WeChatDto | void,
  config?: RequestConfig
): Promise<any> {
  return resource.postNoAuth('/api/wechat/querySignatureByPost', req, config);
}
